import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, Star, Check, Sparkles } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative overflow-hidden pt-8 pb-20 lg:pt-20 lg:pb-32 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-100">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-101">
        {/* Left Column: Copy */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="text-center lg:text-left z-10" data-id="element-102">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/10 border border-accent/20 text-accent-dark mb-6 animate-pulse-fast" data-id="element-103">
            <Sparkles className="w-4 h-4 text-accent" fill="currentColor" data-id="element-104" />
            <span className="text-sm font-bold tracking-wide uppercase" data-id="element-105">
              ¡Oferta por tiempo limitado!
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-brown leading-tight mb-6" data-id="element-106">
            Tu talento no tiene edad, y ahora,{' '}
            <span className="text-pink-gradient italic relative" data-id="element-107">
              tampoco tiene límites.
              <svg className="absolute w-full h-3 -bottom-1 left-0 text-accent/30 -z-10" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-108">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="8" fill="none" data-id="element-109" />
              </svg>
            </span>
          </h1>

          <p className="text-lg sm:text-xl text-brown-light font-sans mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-110">
            El Método "Hogar Dorado": Cómo ganar tus primeros $500 extras usando
            solo tu WhatsApp, sin complicaciones tecnológicas.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center mb-8" data-id="element-111">
            <Button variant="accent" className="group glow-pink" onClick={scrollToOffer} data-id="element-112">
              ¡SÍ! QUIERO EMPEZAR YA
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-113" />
            </Button>
            <div className="flex flex-col items-start bg-white/50 p-2 rounded-lg border border-gold/10" data-id="element-114">
              <span className="text-2xl font-bold text-accent" data-id="element-115">$6.36 USD</span>
              <span className="text-xs text-brown-light line-through decoration-red-400" data-id="element-116">
                Valor real: $97
              </span>
            </div>
          </div>

          {/* Qualifiers */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start text-sm text-brown-light/80" data-id="element-117">
            <div className="flex items-center gap-2" data-id="element-118">
              <div className="bg-green-100 rounded-full p-1" data-id="element-119">
                <Check className="w-3 h-3 text-green-600" data-id="element-120" />
              </div>
              <span data-id="element-121">Sin computadora</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-122">
              <div className="bg-green-100 rounded-full p-1" data-id="element-123">
                <Check className="w-3 h-3 text-green-600" data-id="element-124" />
              </div>
              <span data-id="element-125">Sin inglés avanzado</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-126">
              <div className="bg-green-100 rounded-full p-1" data-id="element-127">
                <Check className="w-3 h-3 text-green-600" data-id="element-128" />
              </div>
              <span data-id="element-129">Desde casa</span>
            </div>
          </div>
        </motion.div>

        {/* Right Column: Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative mx-auto lg:mx-0" data-id="element-130">
          <div className="absolute -inset-4 bg-accent/20 rounded-full blur-3xl opacity-50 animate-pulse" data-id="element-131"></div>
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white/50 transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-132">
            <img src="https://cdn.magicpatterns.com/uploads/jQ1hNyGeqQXZoZGEs3CG5K/heylloyd-image-1771650313549.png" alt="Mujer latina emprendedora usando tablet" className="w-full h-auto object-cover max-w-md mx-auto" data-id="element-133" />

            {/* Overlay Badge */}
            <div className="absolute top-4 right-4 bg-accent text-white font-bold px-4 py-2 rounded-full shadow-lg transform rotate-3 border-2 border-white" data-id="element-134">
              ¡93% OFF HOY!
            </div>
          </div>

          {/* Floating Badge */}
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 1,
          duration: 0.5
        }} className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl border border-accent/20 max-w-[200px] hidden sm:block" data-id="element-135">
            <div className="flex items-center gap-2 mb-1" data-id="element-136">
              <div className="flex text-gold" data-id="element-137">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-138" />)}
              </div>
            </div>
            <p className="text-xs text-brown font-medium" data-id="element-139">
              "Por fin algo que entiendo y puedo usar hoy mismo."
            </p>
            <p className="text-xs text-accent mt-1 font-bold" data-id="element-140">- María G.</p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}